var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersionApproveTitleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23984 2.35879L5.08151 3.92546C4.12318 4.28379 3.33984 5.41712 3.33984 6.43379V12.6255C3.33984 13.6088 3.98984 14.9005 4.78151 15.4921L8.36484 18.1671C9.53984 19.0505 11.4732 19.0505 12.6482 18.1671L16.2315 15.4921C17.0232 14.9005 17.6732 13.6088 17.6732 12.6255V6.43379C17.6732 5.40879 16.8898 4.27546 15.9315 3.91712L11.7732 2.35879C11.0648 2.10046 9.93151 2.10046 9.23984 2.35879Z",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04297 10.3921L9.38464 11.7337L12.968 8.15039",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionApproveTitleIcon);
export default __webpack_public_path__ + "static/media/version_approve_title_icon.b08d2c909ff97a522aaf1b1464579751.svg";
export { ForwardRef as ReactComponent };